"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function moveTo(x, y) {
    return 'M' + x + ',' + y;
}
exports.moveTo = moveTo;
function lineTo(x, y) {
    return 'L' + x + ',' + y;
}
exports.lineTo = lineTo;
function circleArc(r, cx, cy, clockwise) {
    return this.arc(r, r, cx, cy + r, true, clockwise) + this.arc(r, r, cx, cy - r, true, clockwise);
}
exports.circleArc = circleArc;
function arc(rx, ry, endX, endY, largeArc, clockwise) {
    return 'A' + rx + ',' + ry + ' 0 ' + (largeArc ? 1 : 0) + ',' + (clockwise ? 1 : 0) + ' ' + endX + ',' + endY;
}
exports.arc = arc;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/data-coin/svg-utils.js
// module id = 511
// module chunks = 0 1 2 3 4 5 6